import React from "react";
import {observer} from "mobx-react-lite";
import {Alert} from "antd";
import {usersModel} from "../../../../../../entities/users";

export const Errors = observer(() => {
  return (
    Object.values(usersModel.errors).map((error, index) => (
      <Alert key={index} style={{display: 'block', margin: '15px 0'}} message={error} type="error"/>
    ))
  )
})
